import React, {ReactNode} from 'react';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {SimpleDropdown} from '../../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {Icon, IconName} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {MacroInputDropdownBoxCoordinator} from './common/macroInputDropdownBoxCoordinator';
import {
  StyledMacroInputDropdownPlaceholderDiv,
  StyledMacroInputDropdownValueDiv,
} from './common/macroInputDropdownStyles';
import {MacroInputCommonProps} from './common/macroInputTypes';

/*
 * Props.
 */

interface MacroInputDropdownProps<T> extends MacroInputCommonProps<T> {
  renderValue: (value: T) => ReactNode;
  dropdownItems: ReadonlyArray<{label: ReactNode; value: T}>;
  placeholderIcon?: IconName;
}

/*
 * Component.
 */

export const MacroInputDropdown = <T,>({
  value,
  onChange,
  description,
  label,
  renderValue,
  dropdownItems,
  placeholderIcon = 'formattingListSmall',
}: MacroInputDropdownProps<T>) => (
  <MacroInputDropdownBoxCoordinator<T>
    value={value}
    renderDropdown={(popoverProps) => (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <SimpleDropdown {...popoverProps}>
        {dropdownItems.map((dropdownItem, i) => (
          <SimpleDropdownItem
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            onSelect={() => onChange(dropdownItem.value)}
            isChecked={value === dropdownItem.value}
          >
            {dropdownItem.label}
          </SimpleDropdownItem>
        ))}
      </SimpleDropdown>
    )}
    label={label}
    description={description}
    renderValue={renderValue}
    placeholder={
      <StyledMacroInputDropdownValueDiv>
        <StyledMacroInputDropdownPlaceholderDiv>
          <Icon name={placeholderIcon} />
          <Trans id="macro-input-boolean-placeholder">Select option</Trans>
        </StyledMacroInputDropdownPlaceholderDiv>
      </StyledMacroInputDropdownValueDiv>
    }
  />
);
